module.exports = __webpack_public_path__ + "img/XP.ec50d6cb.svg";